export default __webpack_public_path__ + "static/media/star-value.6b4503d0.jpeg";